import { createContext, useState } from "react";
import dayjs from "dayjs";

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
    const [data, setData] = useState(null);
    const [dateRange, setDateRange] = useState({
        start: dayjs().startOf("month").format("YYYY-MM-DD"),
        end: dayjs().format("YYYY-MM-DD"),
    });

    return (
        <DashboardContext.Provider value={{ data, setData, dateRange, setDateRange }}>
            {children}
        </DashboardContext.Provider>
    );
};
